import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-preco-molicar',
  templateUrl: './consulta-preco-molicar.component.html',
  styleUrls: ['./consulta-preco-molicar.component.scss']
})
export class ConsultaPrecoMolicarComponent implements OnInit {


  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  msg;

  @Input() token = '';

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {

  }

}
